import isFunction from "lodash/isFunction";
import isNil from "lodash/isNil";
import LoanFilePreview from "../../screens/LoanDrilldownScreen/tabs/LoanDrilldownFilesTab/LoanFilePreview";
import SideCardModal from "./SideCardModal";

const FilePreviewSideModal = ({ file, loan, containerId, type, onClose }) => {
  const handleClose = () => {
    if (isFunction(onClose)) {
      onClose(null);
    }
  };

  if (isNil(file)) return null;
  return (
    <SideCardModal
      hideHeader
      // title={file?.file_display_name || "File Preview"}
      show={!isNil(file)}
      onClose={handleClose}
      suppressBodyPadding
    >
      <LoanFilePreview
        loan={loan}
        fileObject={file}
        onClose={handleClose}
        type={type}
        containerId={containerId || file?.containerName}
        // sx={{ overflowY: "auto" }}
      />
    </SideCardModal>
  );
};

export default FilePreviewSideModal;
